import { CourseAuthor } from "@jelly/lesson";
import appConfig from "appConfig";

const author: CourseAuthor = {
  name: "Émilie Carayol",
  title: "Acoustician at Kahle Acoustics",
  description: `Émilie Carayol was born in 1992 in France. She studied at the University Pierre et Marie Curie, Paris. In 2013, she completed a double Bachelor degree, the first in Engineering Sciences and the second in Musicology. For the former, she notably studied signal processing, and fluid and solid mechanics. As part of her Bachelor degree, she went on an Erasmus exchange to study sciences and musicology at the Universidad Complutense in Madrid, Spain. In 2015, she obtained her Master degree in Architectural Acoustics from the University Pierre et Marie Curie. Émilie joined Kahle Acoustics in January 2017 as an acoustician, and since then has been contributing to the development of auralisation at Kahle Acoustics while working on European-based projects be they new build, in-situ tunings or renovations.



  <ul>
    <li><a href="https://kahle.be/en/cv/carayol.html" target="_blank">Kahle Acoustics</a></li>
    </ul>
  `,
  imageUrl: appConfig.ASSETS_URL + "/05/authors/emilie-carayol.jpg",
};

export default author;
